import { render, staticRenderFns } from "./UserOrgForm.vue?vue&type=template&id=6a8a21b0&scoped=true"
import script from "./UserOrgForm.vue?vue&type=script&lang=js"
export * from "./UserOrgForm.vue?vue&type=script&lang=js"
import style0 from "./UserOrgForm.vue?vue&type=style&index=0&id=6a8a21b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8a21b0",
  null
  
)

export default component.exports